import Message from "./Message.jsx";

const Messages = () => {
	return (
		<div className=' relative w-full  p-6 overflow-hidden'>
			<Message />
			{/* <Message />
			<Message /> */}
			{/* <Message />
			<Message />
			<Message />
			<Message />
			<Message />
			<Message />
			<Message />
			<Message />
			<Message /> */}
		</div>
	);
};
export default Messages;